import { Checkbox, type CheckboxProps } from "@mantine/core";
import React from "react";

import styles from "./CheckboxGroup.module.scss";

export const StyledCheckbox: React.FC<CheckboxProps> = ({
  className,
  ...props
}) => (
  <Checkbox
    className={`${styles.styledCheckbox} ${className ?? ""}`}
    {...props}
  />
);
